(function () {
    'use strict';

    var module = angular.module('uwAgenda.ringfoon');
    module.directive('contactInfoActions', ['CallsService', 'EmailService', 'SharedAgendaService', ContactInfoActionsDirectivFn]);

    /* actions on contact-infos directive */
    function ContactInfoActionsDirectivFn(CallsService, EmailService, SharedAgendaService) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                contactInfo: '@', // value of contact-info
                contactInfoType: '@', // type of them (mail, mobile, etc)
                contactCaption: '@?', // caption of contact
                userId: '@', // user-id of contact
                agendaCaption: '@', // caption of agenda
                agendaId: '@', // agenda id
                immediate: '@?', // immediate call
                notDialable: '@?', // not dialable
                stopPropagation: '=' // stop propagation of upper events
            }
        };
        return directive;

        function link(scope, element) {
            activate();

            // do the action depending on type
            function doAction() {                                 

                // email-type ?
                if (scope.contactInfoType === "3") { // email
                    // write email to
                    EmailService.writeTo(scope.contactInfo);
                } // if
                else if (scope.contactInfoType === "5") { // website
                    window.open('http://' + scope.contactInfo, "_blank");
                } // else if
                else if (scope.contactInfoType === "1" || scope.contactInfoType === "2") { // phone or mobile
                    // dialable ?
                    if (scope.notDialable === "true") {
                        return;
                    }                    

                    // set new values
                    CallsService.outgoing.phonenumber = scope.contactInfo;
                    CallsService.outgoing.caption = scope.contactCaption;
                    CallsService.outgoing.contactInfoType = scope.contactInfoType;
                    CallsService.outgoing.userId = scope.userId;
                    CallsService.outgoing.immediate = scope.immediate && scope.immediate === 'true' ? true : false;
                    CallsService.outgoing.agendaCaption = scope.agendaCaption;
                    CallsService.outgoing.agendaId = scope.agendaId;
                    
                    // show modal
                    CallsService.showDialModal();
                } // else if
            } // dial

            // activate directive
            function activate() {
                scope.immediate = scope.immediate !== undefined ? true : false;
                scope.agendaCaption = scope.agendaCaption === '' ? SharedAgendaService.data.currentAgenda.owner.caption : scope.agendaCaption;
                scope.agendaId = scope.agendaId === '' ? SharedAgendaService.data.currentAgenda.id : scope.agendaId;


                // contact info available ?
                if (scope.contactInfo !== null && scope.contactInfo !== "") {
                    element.on('click', function (event) {
                        // do action
                        // propagation dynamic because in taskbar the correct agenda should be loaded and switching agenda is on parent directive
                        if (scope.stopPropagation)
                        {
                            event.stopPropagation();
                        }
                        
                        doAction();
                    });
                } // if                
            } // activate

            // on destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });


        } // link
    }
})();